import React from 'react'
import {ServicesCard} from './index'

const ServicesList = () => {
    return (
        <div className="services-container-content-list">
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
           <ServicesCard />
        </div>
    )
}

export default ServicesList
